// Müşteri yorumları — ana sayfa carousel

const testimonials = [
  {
    id: 1,
    text: 'Kombimiz bir anda arızalandı, aynı gün geldiler ve sorunu hızlıca çözdüler. Hem fiyat hem işçilik çok güzeldi. Kesinlikle tavsiye ederim.',
    customerName: 'Mehmet K.',
    location: 'Nilüfer, Bursa',
  },
  {
    id: 2,
    text: 'Klima bakımı için aradım, randevu saatinde geldiler. Çok temiz ve düzenli çalıştılar. Profesyonel bir ekip.',
    customerName: 'Ayşe T.',
    location: 'Osmangazi, Bursa',
  },
  {
    id: 3,
    text: 'Çamaşır makinem çalışmıyordu, başka servisler değişim önerdi. Üç Kardeşler ekibi tamir ederek bana ciddi maliyetten kurtardı.',
    customerName: 'Burak Y.',
    location: 'Yıldırım, Bursa',
  },
  {
    id: 4,
    text: 'Kombimizin düzenli bakımını yaptırdık, şimdi daha verimli çalışıyor. Randevu saatinde geldiler, işlerini titizlikle tamamladılar.',
    customerName: 'Zeynep A.',
    location: 'Özlüce, Bursa',
  },
  {
    id: 5,
    text: 'Klima arızası nedeniyle servis çağırdık, sorunumuzu kısa sürede çözdüler. Güler yüzlü ve çözüm odaklı bir ekip.',
    customerName: 'Ramazan Y.',
    location: 'Beşevler, Bursa',
  },
  {
    id: 6,
    text: 'Bulaşık makinesindeki ses sorununu giderdiler, temiz ve düzenli çalıştılar. Fiyat konusunda da net ve şeffaf davrandılar.',
    customerName: 'Ece T.',
    location: 'Gürsu, Bursa',
  },
  {
    id: 7,
    text: 'Buzdolabımız soğutmuyordu, aynı gün müdahale ettiler. Parça değişimi gerektiğinde önce bilgilendirdiler, güven verdiler.',
    customerName: 'Sevim D.',
    location: 'Osmangazi, Bursa',
  },
  {
    id: 8,
    text: 'Petek temizliği sonrası evimiz belirgin şekilde daha hızlı ısındı. Ekip dakik, işçilik garantili memnun kaldık.',
    customerName: 'Ali R.',
    location: 'Nilüfer, Bursa',
  },
  {
    id: 9,
    text: 'Evimizin kombisi için yaptıkları bakımdan çok memnun kaldık. Nazik iletişim, profesyonel hizmet tekrar tercih edeceğiz.',
    customerName: 'Fatma S.',
    location: 'Kestel, Bursa',
  },
];

export default testimonials;
